@if (show && (isOverdue || isDue)) {
  <span [class]="chipClass">
    @if (isOverdue) {
      <ng-container i18n>{daysOverdue, plural, =1 {1 day late} other {{{ daysOverdue }} days late}}</ng-container>
    } @else {
      <ng-container i18n>{daysUntilDue, plural,
        =0 {due today}
        =1 {due in 1 day}
        other {due in {{ daysUntilDue }} days}
      }</ng-container>
    }
  </span>
}
